export const initialState = {
  heading: "",
  subHeading: "",
  newsDate: new Date(),
  yt_embeded_link: "",
  images: [],
  contents: [],
  videos: [],
  tags: [],
  isFreeze: true,

  allNews: [],
  stories: [],
  showStory: null,

  isMobile: false,
};

const reducer = (state, action) => {
  console.log(action);

  if (action.type === "ADD_ALL_NEWS") {
    return {
      ...state,
      allNews: action.payload.allNews,
    };
  }

  if (action.type === "ADD_STORIES") {
    return {
      ...state,
      stories: action.payload.stories,
    };
  }

  if (action.type === "ADD_SHOW_STORY") {
    return {
      ...state,
      showStory: action.payload.showStory,
    };
  }

  if (action.type === "INITIALIZE") {
    let {
      heading,
      sub_heading,
      news_date,
      yt_embeded_link,
      images,
      contents,
      videos,
      tags,
      is_freeze,
    } = action.payload.data;

    return {
      heading: heading,
      subHeading: sub_heading,
      newsDate: news_date,
      yt_embeded_link: yt_embeded_link,
      images: images,
      contents: contents,
      videos: videos,
      tags: tags,
      isFreeze: is_freeze,
    };
  }

  if (action.type === "RE_INITIALIZE") {
    return {
      heading: "",
      subHeading: "",
      newsDate: "",
      yt_embeded_link: "",
      images: [],
      contents: [],
      videos: [],
      tags: [],
      freeze_news: true,
    };
  }

  if (action.type === "Add_HEADING") {
    return {
      ...state,
      heading: action.payload.heading,
    };
  }

  if (action.type === "Add_SUBHEADING") {
    return {
      ...state,
      subHeading: action.payload.subHeading,
    };
  }
  if (action.type === "ADD_IMAGE") {
    return {
      ...state,
      images: [...state.images, action.payload?.image],
    };
  }
  if (action.type === "ADD_VIDEO") {
    return {
      ...state,
      videos: [...state.videos, action.payload?.video],
    };
  }

  if (action.type === "DELETE_CONTENT") {
    return {
      ...state,
      contents: state?.contents.filter(
        (cont, idx) => idx !== action.payload.index
      ),
    };
  }

  if (action.type === "ADD_CONTENT") {
    let index = action.payload?.index;
    return {
      ...state,
      contents:
        index === -1
          ? [...state.contents, action.payload.content]
          : state.contents?.map((content, idx) =>
              idx === index ? action.payload?.content : content
            ),
    };
  }
  if (action.type === "ADD_YT_EMBEDED") {
    return {
      ...state,
      yt_embeded_link: action.payload?.yt_embeded_link,
    };
  }
  if (action.type === "ADD_TAG") {
    let index = action.payload.index;
    return {
      ...state,
      tags:
        index === -1
          ? [...state.tags, action.payload.tag]
          : state.tags?.filter((tag, idx) => idx !== index),
    };
  }
  if (action.type === "ADD_FREEZE") {
    return {
      ...state,
      isFreeze: action.payload.isFreeze,
    };
  }
  if (action.type === "ADD_NEWSDATE") {
    return {
      ...state,
      newsDate: action.payload.newsDate,
    };
  }

  if (action.type === "DELETE_NEWS") {
    return {
      ...state,
      allNews: state?.allNews.filter(
        (news, idx) => news?.news_id !== action.payload.newsId
      ),
      stories: state?.stories.filter(
        (news, idx) => news?.news_id !== action.payload.newsId
      ),
    };
  }

  if (action.type === "SET_MOBILE")
    return { ...state, isMobile: action.payload.isMobile };
};

export default reducer;
